import axios from '@/assets/http';

export default {
    get(params) {
        return axios.get(`/api/v1/lifestyle`, {
            params: params
        });
    },
    getByTag(params) {
        return axios.get(`/api/v1/lifestyle/get`, {
            params: params
        });
    },
    getInfo(params) {
        return axios.get(`/api/v1/lifestyle/${params.id}`, {
            params: params
        });
    },
    getTagList() {
        return axios.get(`/api/v1/lifestyle/tag`);
    },
    getCityList() {
        return axios.get(`/api/v1/city/open/get`);
    },
}